import { ISHARE } from '.';
import { processURL } from '../../../../../utils/static-pages/urlProcessor';
import { handleTrack } from '../../../../../utils/tracker';
import { getSocialMediaData } from '../../utils';

export const SocialMedia = ({ url, domain, language }: ISHARE): JSX.Element => {
  const socialShare = (name: string, href: string) => {
    handleTrack({ label: `socialShare_${name}`, url: href });
    window.open(
      href,
      '',
      'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600'
    );
    return false;
  };

  const whatsapp = `https://api.whatsapp.com/send/?text=${processURL(
    url,
    language,
    domain
  )}`;
  const linkedin = `https://www.linkedin.com/sharing/share-offsite/?url=${processURL(
    url,
    language,
    domain
  )}`;
  const facebook = `https://www.facebook.com/sharer/sharer.php?u=${processURL(
    url,
    language,
    domain
  )}`;
  const twitter = `https://twitter.com/share?url=${processURL(
    url,
    language,
    domain
  )}`;

  const socialMediaData = getSocialMediaData({
    linkedin,
    facebook,
    twitter,
    whatsapp,
  });

  return (
    <div data-testid="social-media">
      {socialMediaData.map((item) => {
        return (
          <a
            className="w-full cursor-pointer"
            key={item.name}
            href={item.link}
            id={`${item.name}Share`}
            data-action={`${item.action || ''}`}
            onClick={() => socialShare(item.name, item.link)}
            target="_blank"
            rel="noopener noreferrer"
            title={`share on ${item.name}`}
          >
            <div className="w-full p-3 flex items-center">
              <img
                src={item.icon}
                alt=""
                className="sm:w-8 sm:h-8"
                width={48}
                height={48}
              />
            </div>
          </a>
        );
      })}
    </div>
  );
};
